import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert, 
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {reports} from "../../../components/Report.js";
export default class Billings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_view: false,

      filter_search: "",
      filter_start_date: format_date(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 1
        ),
        "yyyy-mm-dd",
        "en"
      ),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_status: "",
      filter_warehouse_id: "",

      data: [],
      count: 10,
      data_customer: [],
      data_invoice: [],
      data_warehouse: [],

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",

      filter_bill_search: "",
      filter_bill_date: "",
      filter_bill_duedate: "",

      billing_document_no: "",
      credit_note: [],
    };
    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_warehouse_id,
    } = this.state;
    let data, count, data_customer, data_warehouse;
    loading(true);
    let [result, result_customer, result_warehouse] = await Promise.all([
      GET("admin/billing-notes/list", {
        page: 0,
        page_size: 10000,
        data_search: filter_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        status_code: filter_status,
      }),
      GET("admin/setting/customers/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      let result_product = await Promise.all(
        data.map((e) => GET("admin/billing-notes/list", { uid: e.uid }))
      );
      
      data = data.map((e, i) => ({
        ...e,
        transaction_list: result_product[i]?.data?.invoice,
      }));
      data = data.filter(
        (e) =>
          JSON.stringify(e).includes(filter_warehouse_id) ||
          !filter_warehouse_id
      );
      
    }
    if (result_customer?.status) {
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
      }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }

    this.setState({
      data,
      count,
      data_customer,
      data_warehouse,
    });
    loading(false);
  };

  ExportPDF = async () => {
    const table = this.tableRef.current;
    if (!table) return [];

    const rows = Array.from(table.querySelectorAll("tbody tr"));

    const data_list = rows.map((tr) => {
      const cells = Array.from(tr.querySelectorAll("td"));
      return cells.map((td) => td.innerText.trim());
    });

    const obj = {
          table: {
            headerRows: 0,
            widths: ["auto","*","auto",65,"auto","auto","auto","auto"],
            body: [
              [
                { text: "วันที่", alignment: "center" },
                { text: "เลขที่ใบวางบิล", alignment: "center" },
                { text: "ชื่อลูกค้า", alignment: "center" },
                { text: "กำหนดชำระ", alignment: "center" },
                { text: "สถานะ", alignment: "center" },
                "",
                "",
                "",
              ],
              ...data_list.map((item, index) => {
                let border = [1, 0, 1, 0];let color = "#ffffff";
                if(index === data_list.length - 1){
                  border = [1, 0, 1, 1];
                }
                if(item[0]){
                  border = !item[0].includes("วันที่ใบแจ้งหนี้") ? [0, 0, 0, 0]: [1, 1, 1, 1];
                  color = data_list[index+1].includes("วันที่ใบแจ้งหนี้") ? "#d8d8d8": "#ffffff";
                  return [
                      { text: item[0], alignment: "center", fillColor: color, border: [1, border[1], border[2], border[3]] },
                      { text: item[1], alignment: "center", fillColor: color, border },
                      { text: item[2], alignment: "right", fillColor: color, border },
                      { text: item[3], alignment: "center", fillColor: color, border },
                      { text: item[4], alignment: "right", fillColor: color, border },
                      { text: item[5], alignment: "right", fillColor: color, border },
                      { text: item[6], alignment: "right", fillColor: color, border },
                      { text: item[7], alignment: "right", fillColor: color, border: [border[0], border[1], 1, border[3]] },
                    ]
                }
                else{
                   border = [1, 1, 1, 1];
                  return [
                    { text: item[1], alignment: "right", colSpan: 2, border },
                    "",
                    { text: item[2], alignment: "right", fillColor: color, border },
                    { text: item[3], alignment: "center", fillColor: color, border },
                    { text: item[4], alignment: "right", fillColor: color, border },
                    { text: item[5], alignment: "right", fillColor: color, border },
                    { text: item[6], alignment: "right", fillColor: color, border },
                    { text: item[7], alignment: "right", border },
                  ]}
                }
            ),
            ],
          },
        };
    reports("รายการใบวางบิล", obj, 14, "portrait");
  }
  render() {
    const {
      modal_create,
      modal_view,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_warehouse_id,
      data,
      count,
      data_invoice,
      data_customer,
      data_warehouse,

      id,
      uid,
      bank_name,
      account_number,
      account_name,
      customer_id,

      filter_bill_search,
      filter_bill_date,
      filter_bill_duedate,
      billing_document_no,
      credit_note,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการใบวางบิล</h4>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />

              <div className="wpx-200 me-2 mb-2">
                <select
                className="form-select wpx-200 me-2 mb-2 mt-2"
                onChange={(e) => {
                  this.setState({ filter_warehouse_id: e.target.value });
                }}
                value={filter_warehouse_id}
              >
                <option value="">
                  ทั้งหมด
                </option>
                {data_warehouse.map(e=>(
                <option value={e.label}>{e.label}</option>
                ))}
              </select>
              </div>
              <select
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="">เลือกสถานะ</option>
                <option value="รอชำระ">รอชำระ</option>
                <option value="ใบวางบิล">ใบวางบิล</option>
                <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                <option value="เกินกำหนดชำระ">เกินกำหนดชำระ</option>
                <option value="ชำระแล้ว">ชำระแล้ว</option>
                <option value="ยกเลิก">ยกเลิก</option>
              </select>

              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>

              <div className="ms-auto">
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                  filename="รายการใบวางบิล"
                  sheet="รายการใบวางบิล"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>
            <div className="table-responsive" style={{maxHeight:"70vh"}}>
              <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}
              >
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่</td>
                    <td className="text-nowrap">เลขที่ใบวางบิล</td>
                    <td className="text-nowrap">ชื่อลูกค้า</td>
                    <td className="text-nowrap">กำหนดชำระ</td>
                    <td className="text-nowrap">สถานะ</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <>
                      <tr>
                        <td className="text-nowrap bg-primary-light">
                          {item.created_at ? format_date(item.created_at) : ""}
                        </td>
                        <td className="text-nowrap bg-primary-light">
                          {item.document_no || ""}
                        </td>
                        <td className="text-nowrap bg-primary-light">
                          {item?.customer?.full_name || "-"}
                        </td>
                        <td className="text-nowrap bg-primary-light">
                          {item.sale?.due_date
                            ? format_date(item.sale?.due_date)
                            : format_date(new Date())}
                        </td>
                        <td className="text-nowrap bg-primary-light">
                          {item.status}
                        </td>
                        <td className="bg-primary-light"></td>
                        <td className="bg-primary-light"></td>
                        <td className="bg-primary-light"></td>
                      </tr>
                      <tr>
                        <td className="text-nowrap fw-bold">
                          วันที่ใบแจ้งหนี้
                        </td>
                        <td className="text-nowrap fw-bold">
                          เลขที่ใบแจ้งหนี้
                        </td>
                        <td className="text-nowrap fw-bold text-end">
                          ยอดเงินสุทธิ
                        </td>
                        <td className="text-nowrap fw-bold">เลขที่ใบลดหนี้</td>
                        <td className="text-nowrap fw-bold text-end">
                          ยอดใบลดหนี้
                        </td>
                        <td className="text-nowrap fw-bold text-end">
                          ชำระแล้ว
                        </td>
                        <td className="text-nowrap fw-bold text-end">
                          ค้างชำระ
                        </td>
                        <td className="text-nowrap fw-bold text-end">
                          ยอดคืนลูกค้า
                        </td>
                      </tr>

                      {item.transaction_list?.map((tx, tx_index) => (
                        <tr>
                          <td className="text-nowrap">
                            {format_date(tx.sale?.created_at)}
                          </td>
                          <td className="text-nowrap">
                            {tx.document_no || "-"}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(tx.sale?.amount)}
                          </td>
                          <td className="text-nowrap">
                            {tx.credit_note
                              .map((e) => e.document_no)
                              .toString() || "-"}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(total(tx.credit_note, "amount"))}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(tx.sale?.total_pay)}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(tx.sale?.amount) -
                                total(tx.credit_note, "amount") -
                                Number(tx.sale?.total_pay) >=
                                0
                                ? Number(tx.sale?.amount) -
                                    total(tx.credit_note, "amount") -
                                    Number(tx.sale?.total_pay)
                                : "0.00"
                            )}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(tx.sale?.amount) -
                                total(tx.credit_note, "amount") -
                                Number(tx.sale?.total_pay) <
                                0
                                ? Number(tx.sale?.amount) -
                                    total(tx.credit_note, "amount") -
                                    Number(tx.sale?.total_pay)
                                : "0.00"
                            )}
                          </td>
                        </tr>
                      ))}
                      <tr className="fw-bold">
                        <td></td>
                        <td>ผลรวม</td>
                        <td className="text-nowrap text-end">
                          {(() => {
                            let _total = 0;
                            for (let tx of item.transaction_list) {
                              _total += Number(tx.sale?.amount);
                            }
                            return toFixed(_total);
                          })()}
                        </td>
                        <td></td>
                        <td className="text-nowrap text-end">
                          {(() => {
                            let _total = 0;
                            for (let tx of item.transaction_list) {
                              _total += Number(total(tx.credit_note, "amount"));
                            }
                            return toFixed(_total);
                          })()}
                        </td>
                        <td className="text-nowrap text-end">
                          {(() => {
                            let _total = 0;
                            for (let tx of item.transaction_list) {
                              _total += Number(tx.sale?.total_pay);
                            }
                            return toFixed(_total);
                          })()}
                        </td>
                        <td className="text-nowrap text-end">
                          {(() => {
                            let _total = 0;
                            for (let tx of item.transaction_list) {
                              _total +=
                                Number(tx.sale?.amount) -
                                total(tx.credit_note, "amount") -
                                Number(tx.sale?.total_pay);
                            }
                            return toFixed(_total >= 0 ? _total : 0);
                          })()}
                        </td>
                        <td className="text-nowrap text-end">
                          {(() => {
                            let _total = 0;
                            for (let tx of item.transaction_list) {
                              _total +=
                                Number(tx.sale?.amount) -
                                total(tx.credit_note, "amount") -
                                Number(tx.sale?.total_pay);
                            }
                            return toFixed(_total < 0 ? _total : 0);
                          })()}
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
